import React, { useState } from 'react';
import { useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DSIconButton from '../../../../../design-system/DSIconButton';
import DSPaper from '../../../../../design-system/Paper/DSPaper';
import DSTooltip from '../../../../../design-system/DSTooltip';
import { COLLECTION_COVER_BORDER_RADIUS } from '../../../../../design-system/Collection';

type CollectionAssetFileInputUploadedProps = {
  secureUrl: string;
  fileName: string;
  onRemoveFile: () => void;
};

const CollectionAssetFileInputUploaded = ({
  secureUrl,
  fileName,
  onRemoveFile,
}: CollectionAssetFileInputUploadedProps) => {
  const { spacing, palette } = useTheme();
  const [isHovered, setIsHovered] = useState(false);

  return (
    <DSTooltip title={fileName} placement="top">
      <DSPaper
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        sx={{
          display: 'flex',
          aspectRatio: '1',
          justifyContent: 'center',
          alignItems: 'center',
          alignSelf: 'stretch',
          borderRadius: COLLECTION_COVER_BORDER_RADIUS,
          border: 'none',
          backgroundColor: palette.white[5],
          position: 'relative',
          overflow: 'hidden',
          cursor: 'pointer',
        }}
      >
        <img
          src={secureUrl}
          alt={fileName}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            opacity: isHovered ? 0.7 : 1,
            transition: 'opacity 0.3s ease',
          }}
        />

        <DSIconButton
          onClick={onRemoveFile}
          sx={{
            position: 'absolute',
            // The tile corner is rounded by side ÷ 3 and clips overflow, so
            // the button must sit inside the curve (≥ ~9.8% in from each edge).
            top: '12%',
            right: '12%',
            padding: spacing(1),
            opacity: isHovered ? 1 : 0,
            backgroundColor: 'transparent',
            backdropFilter: 'blur(4px)',
            '&:hover': {
              transform: 'scale(1.1)',
              background: 'transparent',
            },
            color: palette.common.white,
            transition: 'all 0.3s ease',
            zIndex: 2,
          }}
        >
          <CloseIcon />
        </DSIconButton>
      </DSPaper>
    </DSTooltip>
  );
};

export default CollectionAssetFileInputUploaded;
